import { Header, Table } from "@amzn/awsui-components-react";
import { FunctionComponent } from "react";

import { buildColumnDefinitions, getString } from "../../common";
import EmptyTableBox from "../../common/EmptyTableBox/EmptyTableBox";
import { ColumnSetting } from "../../common/utils/config-models";
import auditTrailsTableConfig from "./audit-trails.table-config.json";

const columns: ColumnSetting[] = auditTrailsTableConfig.columns;

export interface AuditTrailsTableProps {
    items?: any[];
}

export const AuditTrailsTable: FunctionComponent<AuditTrailsTableProps> = (props: AuditTrailsTableProps) => {
    // Actions
    const currentColumnDefinitions = buildColumnDefinitions(columns);

    return (
        <Table
            data-testid="order-items-table"
            empty={<EmptyTableBox />}
            header={
                <Header>{getString('auditTrails.table.headerTitle')}</Header>
            }
            columnDefinitions={currentColumnDefinitions}
            loadingText={getString('common.loading')}
            items={props.items!}
            resizableColumns={true}
            wrapLines
        />
    );
};
